import ProgressBar from '@ramonak/react-progress-bar';
export default function ReiniciarTicket( {
	text,
	status,
	remainingBonos,
	maxBonosComercio,
	progresoConvocatoria,
} ) {
	const dashboardAddress = window.location.origin + '/panel-de-comercio';

	const handleReiniciarTicket = ( e ) => {
		e.preventDefault();

		// eslint-disable-next-line no-alert, no-undef
		if ( confirm( '¿Estás seguro de que quieres reiniciar la compra?' ) ) {
			window.location.reload();
		}
	};

	const campaignProgress = Math.ceil( progresoConvocatoria * 100 );

	const progressColor = window
		.getComputedStyle( document.documentElement )
		.getPropertyValue( '--wp--preset--color--primary' );

	return (
		<>
			<div className="sci-bcl-progreso-campana">
				<p>Porcentaje de progreso de la campaña: </p>
				<ProgressBar
					completed={ campaignProgress }
					bgColor={ progressColor }
					transitionDuration="1.5s"
					animateOnRender={ true }
				/>
			</div>
			{ status === 'limited' && (
				<p className="sci-bcl-bonos-restantes">
					Bonos disponibles para canjear: { remainingBonos } /{ ' ' }
					{ maxBonosComercio }
				</p>
			) }

			<div className="sci-bcl-reiniciar-ticket">
				<button id="reiniciar-ticket" onClick={ handleReiniciarTicket }>
					{ ' ' }
					{ text }{ ' ' }
				</button>
				<a className="btn-regular" href={ dashboardAddress }>
					Panel de comercio
				</a>
			</div>
		</>
	);
}
